import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserAuthContextProvider } from './Context/UserAuthContext';

// The build is prerendered (see scripts/prerender.js), so this element
// already has real markup in it when the page loads -- that's for search
// engines and link-preview bots, which never run this script. A real
// visitor's browser does run it: createRoot takes over and renders the
// live, interactive app on top, same as it always has.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>
    <UserAuthContextProvider>

      <App />

    </UserAuthContextProvider>
  </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
